// extracted by mini-css-extract-plugin
module.exports = {"entry":"entry_entry__38qeo","entryContent":"entry_entryContent__1d0wU","explanation":"entry_explanation__3Rsmu","liked":"entry_liked__3fKr1"};